globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.NewArticle = (function(superClass) {

  utils.extend(NewArticle, superClass);

  function NewArticle($html) {
    this.$html = $html;
    NewArticle.__super__.constructor.apply(this, arguments);
  }

  $.extend(NewArticle.prototype, {
    init: function() {
      NewArticle.__super__.init.apply(this, arguments);

      return this;
    },
    callbackSuccess: function(data, successMsg) {
      if (data == null) {
        data = {};
      }
      if (data.response) {
        window.location = data.redirect_url;
      }
    }
  });

  return NewArticle;

})(appCustomerSpace.Modal);
